// IMPORTANT: this file ships in the production bundle. The theme is built once and that single bundle
// is served to BOTH the WP Engine preview origin and indeed.com (Post-Press proxies the same
// HTML/assets), so this sample data is included in production even though it only renders on
// non-production preview hosts. Only ever put fabricated, non-sensitive sample data here — anything
// real or sensitive must come from Post-Press/server injection instead. See previewSampleData.ts.
const mockData = {
  title: 'Job Title(en_US)',
  display: 'Displayed title(en_US)',
  modalData: {
    sourceName: 'Indeed data (US)',
    sourceDate: 'June 2022',
    modalTitleSuffix: 'Hiring Fast Facts',
    sections: [
      {
        name: 'job_seekers',
        label: 'Job Seekers',
        amount: 601920,
        change_amount: -111508,
        date: 'July 2022',
        description: 'Number of job seekers to have clicked on jobs',
        tooltip_info:
          'This is the number of job seekers, as identified by a unique tracking cookie, to have clicked on a job for the selected title(s) and location - if any - in August 2022.',
      },
      {
        name: 'average_salary',
        label: 'Average Salary',
        unit: 'year',
        low: 10,
        high: 60,
        average: 28,
        tooltip_info:
          'Average salary for the selected title(s) and location - if any, as calculated using data from a variety of sources, such as employees, users, and past and present job advertisements on Indeed for a period up to the last 36 months. These figures are provided for the purpose of generalized comparison only.',
      },
      {
        name: 'employers',
        label: 'Employers',
        amount: 8754,
        description: 'Total number of employers with active jobs',
        tooltip_info:
          'The total number of employers with job postings for the selected title and location that received clicks in August 2022.',
      },
      {
        name: 'resumes',
        label: 'Resumes',
        amount: 97233,
        change_amount: 1993,
        date: 'July 2022',
        description:
          'Number of resumes from job seekers available in United States on Indeed',
        tooltip_info:
          'The number of resumes where the most recently listed work experience was in the search selected. Indeed does not guarantee that these job seekers are currently actively seeking employment.',
      },
      {
        name: 'top_5_search_terms',
        label: 'Top 5 search terms by clicks',
        tooltip_info:
          'These are the most popular search terms leading to clicks on jobs for the selected title(s) and location - if any - in August 2022. Note that some common generic phrases, such as "now hiring" or "jobs" may have been filtered out from this top 10.',
        terms: [
          'accounting',
          'accountant',
          'bookkeeper',
          'staff accountant',
          'accounts payable',
        ],
        percentStrings: [
          '22.26',
          '11.11',
          '6.78',
          '5.55',
          '2.11',
        ],
      },
    ],
    ctas: [
      {
        text: 'See more insights',
        show: 'true',
        url: 'https://employers.indeed.com/o/hiring-insights?q=administrative+assistant&l=&country=US',
      },
      {
        text: 'Post a job',
        show: 'true',
        url: 'https://employers.indeed.com/p/post-job?hl=en_US&co=US',
      },
    ],
    localization: {
      locale: 'en-US',
      currency: 'USD',
      sinceMonthFormat: 'since [month]',
      year: 'year',
      month: 'month',
      week: 'week',
      day: 'day',
      hour: 'hour',
      low: 'Low',
      average: 'Average',
      high: 'High',
      marketLabel: 'Want trends specific to your market?',
      zipCodePlaceholder: 'Enter a Zip Code...',
      goToInsightsText: 'Go to insights',
    },
  },
};

export default mockData;
